import { getItemFromCollection } from "directus/src/operations";

export async function fetchInterviewMeta({ interviewId }) {
    try {
        const query = {
            fields: [
                "id",
                "date_scheduled",
                "title",
                "recording_url",
                "status",
                "client_feedback",
                "internal_feedback",
                "transcript",
                "is_cleared",
            ],
        };

        const data = await getItemFromCollection("opening_interviews", interviewId, query);
        return data;
    } catch (error) {
        console.log(error);
        throw error;
    }
}